function Abc(){
    return(
        <div class="gal">
        <div class="gal_1">
            <img src="/images/gear.jpg" alt="Solo Levelling"></img>
            <h2>Luffy Gear 5</h2>
            <p>Luffy's Gear 5 Form</p>
            <button>Action</button>
        </div>
        <div class="gal_1">
            <img src="/images/kaioken.jpg" alt="Naruto"></img>
            <h2>Goku Kaioken</h2>
            <p>Goku goes Kaioken with his SSJ Blue</p>
            <button>Action</button>
        </div>

        <div class="gal_1">
            <img src="/images/sasuks.jpg" alt="Solo Levelling"></img>
            <h2>Naruto vs Sasuke</h2>
            <p>Fight b/t Naruto & Sasuke after War</p>
            <button>Action</button>

        </div>

        <div class="gal_1">
            <img src="/images/arise.jpg" alt="Solo Levelling"></img>
            <h2>Shadow Army</h2>
            <p>Sung  Jin Woo flexes his Shadow Army</p>
            <button>Aura</button>
        </div>

    </div>



    )
}

export default Abc;